export default function SectionHeader({ eyebrow, title, subtitle, align = 'left', light = false }) {
  const alignClass = align === 'center' ? 'mcr-section-header--center' : '';
  const lightClass = light ? 'mcr-section-header--light' : '';

  return (
    <div className={`mcr-section-header ${alignClass} ${lightClass}`.trim()}>
      {eyebrow && <p className="mcr-section-header__eyebrow">{eyebrow}</p>}
      <h2 className="mcr-section-header__title">{title}</h2>
      {subtitle && <p className="mcr-section-header__subtitle">{subtitle}</p>}
    </div>
  );
}
